interface FeatureItem {
  icon: string;
  title: string;
  description: string;
}

const features: FeatureItem[] = [
  {
    icon: 'ri-shield-check-line',
    title: '品质保障',
    description: '久久久久独创九重品质管控体系，从源头到终端全链路把关，确保每一件产品都经得起时间考验。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '长效服务',
    description: '覆盖产品全生命周期的服务体系，2小时响应、48小时解决，让您的每一次体验都安心无忧。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '稳定性能',
    description: '多维冗余设计结合极端环境测试，久久久久产品在各种条件下始终保持卓越稳定的表现。',
  },
  {
    icon: 'ri-tools-line',
    title: '耐久方案',
    description: '模块化可维护设计配合超前寿命规划，久久久久的耐久解决方案让您的投入物超所值。',
  },
];

export default function FeatureSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            久久久久，四大核心优势
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            从品质到服务，从性能到耐久，久久久久以全方位的持久稳定体验，成为您最值得信赖的选择。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-5 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}